import styled from 'styled-components';
import { Box } from '../../../../layout/Box';

export const IconWrapper = styled(Box).withConfig({ displayName: 'IconWrapper' }).attrs({
    position: 'absolute',
    p: 0.25,
    borderRadius: 1,
    background: 'var(--control-secondary-background)',
    backdropFilter: 'blur(20px)',
})``;

export const StatusIconWrapper = styled(Box)
    .withConfig({ displayName: 'StatusIconWrapper' })
    .attrs({
        position: 'relative',
        width: 24,
        height: 24,
        borderRadius: 1,
    })`
        align-content: center;
        justify-items: center;
        cursor: help;
    `;

export const MonetizationIconWrapper = styled(Box)
    .withConfig({ displayName: 'MonetizationIconWrapper' })
    .attrs({
        position: 'absolute',
        bottom: -0.5,
        right: -0.5,
        border: '2px solid var(--background-primary)',
        borderRadius: 999,
    })``;
